var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function LoadedImage(_a) {
    var img = _a.img, className = _a.className;
    if (!img)
        return null;
    var stringBase64 = "data:image/png;base64,".concat(img);
    return (_jsx("div", __assign({ className: "flex items-center justify-center gap-2 py-2" }, { children: _jsx("img", { className: cn("w-80", className), src: stringBase64, alt: "QR Code do Pix" }) })));
}
